import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  findAllUsers,
  findAllManagers,
  findAllBuyers,
  addUser,
  addManager,
  addBuyer,
  deleteUser
} from '../../..//redux/actions/admin';
import { getLocale, getUser } from '../../..//redux/selectors';
import { sendNotification } from '../../..//redux/actions/notifications';
import { withRouter, Link } from 'react-router-dom';
import { findAllSites } from '../../..//redux/actions/sites';

class Users extends Component {
  render = () => {
    const {
      Layout,
      currentLocale,
      users,
      managers,
      buyers,
      inventorySites,
      user,
      findAllUsers,
      findAllManagers,
      findAllBuyers,
      addUser,
      addManager,
      addBuyer,
      deleteUser,
      sendNotification,
      push,
      history,
      findAllSites,
      sites
    } = this.props;
    return (
      <Layout
        currentLocale={currentLocale}
        users={users}
        managers={managers}
        buyers={buyers}
        user={user}
        findAllUsers={findAllUsers}
        findAllManagers={findAllManagers}
        findAllBuyers={findAllBuyers}
        addUser={addUser}
        addManager={addManager}
        addBuyer={addBuyer}
        deleteUser={deleteUser}
        sendNotification={sendNotification}
        push={push}
        history={history}
        findAllSites={findAllSites}
        sites={sites}
        inventorySites={inventorySites}
      />
    );
  };
}

const mapStateToProps = state => ({
  currentLocale: getLocale(state) || {},
  users: state.admin.allUsers || [],
  managers: state.admin.allManagers || [],
  buyers: state.admin.allBuyers || [],
  user: getUser(state) || {},
  sites: state.sites.allSites || [],
  inventorySites: state.sites.inventorySites || []
});

const mapDispatchToProps = {
  getLocale,
  findAllUsers,
  findAllManagers,
  findAllBuyers,
  addUser,
  addManager,
  addBuyer,
  deleteUser,
  sendNotification,
  push,
  findAllSites
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Users)
);
